import { FC } from 'react';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';

import closeOutside from '../../assets/images/icon_close_outside.png';

export const OutSideCloseButton: FC<{
  closeFunc: () => void;
}> = ({ closeFunc }) => {
  const onClickHandler = () => {
    closeFunc();
    window.parent.postMessage({ action: 'fixedBtnShow' }, '*');
  };

  return (
    <div
      className={commonModalClass.outsideBtnContainer}
      onClick={onClickHandler}
    >
      <button className={commonModalClass.outsideBtn}>
        <img
          src={closeOutside}
          alt=""
        />
      </button>
    </div>
  );
};
